import { usePixel } from '../../hooks/use-pixel'
import { useRouteQuery } from '../../hooks/use-route-query'
import { Accounts } from './accounts'

export function AccountsContainer() {
    const query = useRouteQuery()
    usePixel({ page: 'Accounts' })

    const asset = query.get('asset')
    const account = query.get('account')

    return <Accounts asset={asset} account={account} />
}
